var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 41,
    viewBox: "0 0 81 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_1243)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32_1243",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 0,
    width: 41,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6201 0.66H20.6201V40.66H60.6201V0.66Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32_1243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6201 16.1899C40.6201 15.1878 41.4325 14.3754 42.4346 14.3754C43.4367 14.3754 44.2491 15.1878 44.2491 16.1899V14.9922C44.2491 13.9901 45.0615 13.1777 46.0636 13.1777C47.0658 13.1777 47.8782 13.9901 47.8782 14.9922V13.5475C47.8782 12.5301 48.7108 11.678 49.728 11.6974C50.7138 11.7163 51.5072 12.5213 51.5072 13.5116V14.9922C51.5072 13.9901 52.3196 13.1777 53.3217 13.1777C54.3238 13.1777 55.1362 13.9901 55.1362 14.9922V32.5303C55.1362 33.9278 54.6253 35.2057 53.7802 36.1881C53.229 36.8288 52.9299 37.6483 52.9299 38.4935V40.0492C52.9299 40.3867 52.6869 40.6604 52.3873 40.6604H42.5323C42.2327 40.6604 41.9897 40.3868 41.9897 40.0492V37.3505C41.9897 36.6919 41.8079 36.0456 41.4605 35.4861C40.9278 34.6276 40.6201 33.6149 40.6201 32.5304V16.1899Z",
    fill: "url(#paint0_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8162 27.7191C51.2777 27.7191 54.8946 29.8962 54.8946 32.5818C54.8946 35.2675 51.2777 37.4446 46.8162 37.4446C44.9509 37.4446 43.2335 37.0639 41.8661 36.4247C41.7774 36.0953 41.6422 35.7786 41.4606 35.486C40.9278 34.6276 40.6201 33.6149 40.6201 32.5303V29.4619C42.102 28.3967 44.3275 27.7191 46.8162 27.7191Z",
    fill: "url(#paint1_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9026 29.0024C52.7822 29.0024 53.5793 29.354 54.1622 29.9238L56.356 27.7301C57.4169 26.6692 59.137 26.6692 60.1979 27.7301C60.7607 28.2929 60.7607 29.2052 60.1979 29.7679L53.7948 36.1711C52.7654 37.3777 51.2339 38.1431 49.5235 38.1431H48.3063C46.7753 38.1431 45.5342 36.9019 45.5342 35.3709C45.5342 31.8536 48.3855 29.0024 51.9026 29.0024Z",
    fill: "url(#paint2_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5078 14.9922V24.698H52C53.7321 24.698 55.1364 26.1024 55.1364 27.8344V14.9922C55.1364 13.9903 54.3242 13.1776 53.3224 13.1776C52.32 13.1776 51.5078 13.9903 51.5078 14.9922Z",
    fill: "url(#paint3_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8784 13.5117V24.698H51.5076V13.5117C51.5076 12.5093 50.6949 11.6971 49.693 11.6971C48.6906 11.6971 47.8784 12.5093 47.8784 13.5117Z",
    fill: "url(#paint4_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.249 14.9922V24.698H47.8782V14.9922C47.8782 13.9903 47.066 13.1776 46.0636 13.1776C45.0617 13.1776 44.249 13.9903 44.249 14.9922Z",
    fill: "url(#paint5_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6205 16.1899V27.8343C40.6205 26.1022 42.0248 24.6979 43.7569 24.6979H44.2491V16.1899C44.2491 15.1876 43.4369 14.3753 42.4345 14.3753C41.4326 14.3753 40.6205 15.1876 40.6205 16.1899Z",
    fill: "url(#paint6_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0189 31.969L53.793 36.1794C52.7613 37.3841 51.2284 38.1466 49.5181 38.1434L48.3009 38.1412L46.227 38.1373C43.1273 38.1316 40.6192 35.6142 40.6249 32.5145L40.626 31.9369L58.0189 31.969Z",
    fill: "url(#paint7_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1981 29.7675L53.795 36.1707C53.7919 36.1746 53.7887 36.1777 53.7856 36.1816C53.784 36.1832 53.7817 36.1856 53.7801 36.1879C53.2287 36.8287 52.9299 37.6483 52.9299 38.493V40.0491C52.9299 40.3863 52.6868 40.6601 52.3872 40.6601H50.5707L40.6201 30.7103V16.1895C40.6201 15.1879 41.4326 14.3754 42.4342 14.3754C43.4366 14.3754 44.2491 15.1879 44.2491 16.1895V14.9918C44.2491 13.9903 45.0617 13.1777 46.0632 13.1777C47.0656 13.1777 47.8781 13.9903 47.8781 14.9918V13.5471C47.8781 12.5299 48.7111 11.6781 49.7283 11.6969C50.7134 11.7158 51.5072 12.5212 51.5072 13.5118V14.9918C51.5072 14.4907 51.7103 14.0373 52.0389 13.7095C52.3668 13.3808 52.8209 13.1777 53.3213 13.1777C54.3236 13.1777 55.1362 13.9903 55.1362 14.9918V28.9495L56.3558 27.7299C57.417 26.6687 59.137 26.6687 60.1981 27.7299C60.7605 28.2922 60.7605 29.2052 60.1981 29.7675Z",
    fill: "url(#paint8_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6201 16.1899C40.6201 15.1878 39.8077 14.3754 38.8056 14.3754C37.8034 14.3754 36.991 15.1878 36.991 16.1899V14.9922C36.991 13.9901 36.1787 13.1777 35.1765 13.1777C34.1744 13.1777 33.362 13.9901 33.362 14.9922V13.5475C33.362 12.5301 32.5294 11.678 31.5121 11.6974C30.5263 11.7163 29.733 12.5213 29.733 13.5116V14.9922C29.733 13.9901 28.9206 13.1777 27.9185 13.1777C26.9163 13.1777 26.1039 13.9901 26.1039 14.9922V32.5303C26.1039 33.9278 26.6148 35.2057 27.4599 36.1881C28.0112 36.8288 28.3102 37.6483 28.3102 38.4935V40.0492C28.3102 40.3867 28.5532 40.6604 28.8528 40.6604H38.7079C39.0075 40.6604 39.2505 40.3868 39.2505 40.0492V37.3505C39.2505 36.6919 39.4323 36.0456 39.7797 35.4861C40.3124 34.6276 40.6201 33.6149 40.6201 32.5304V16.1899Z",
    fill: "url(#paint9_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4241 27.7191C29.9625 27.7191 26.3456 29.8962 26.3456 32.5818C26.3456 35.2675 29.9625 37.4446 34.4241 37.4446C36.2894 37.4446 38.0068 37.0639 39.3742 36.4247C39.4629 36.0953 39.5981 35.7786 39.7797 35.486C40.3125 34.6276 40.6202 33.6149 40.6202 32.5303V29.4619C39.1383 28.3967 36.9128 27.7191 34.4241 27.7191Z",
    fill: "url(#paint10_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3374 29.0024C28.4578 29.0024 27.6608 29.354 27.0778 29.9238L24.8841 27.7301C23.8231 26.6692 22.1031 26.6692 21.0421 27.7301C20.4794 28.2929 20.4794 29.2052 21.0421 29.7679L27.4453 36.1711C28.4747 37.3777 30.0061 38.1431 31.7166 38.1431H32.9338C34.4648 38.1431 35.7059 36.9019 35.7059 35.3709C35.7058 31.8536 32.8546 29.0024 29.3374 29.0024Z",
    fill: "url(#paint11_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7326 14.9922V24.698H29.2403C27.5083 24.698 26.1039 26.1024 26.1039 27.8344V14.9922C26.1039 13.9903 26.9162 13.1776 27.918 13.1776C28.9204 13.1776 29.7326 13.9903 29.7326 14.9922Z",
    fill: "url(#paint12_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3616 13.5117V24.698H29.7324V13.5117C29.7324 12.5093 30.5451 11.6971 31.547 11.6971C32.5494 11.6971 33.3616 12.5093 33.3616 13.5117Z",
    fill: "url(#paint13_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.991 14.9922V24.698H33.3618V14.9922C33.3618 13.9903 34.174 13.1776 35.1764 13.1776C36.1783 13.1776 36.991 13.9903 36.991 14.9922Z",
    fill: "url(#paint14_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6198 16.1899V27.8343C40.6198 26.1022 39.2155 24.6979 37.4834 24.6979H36.9911V16.1899C36.9911 15.1876 37.8033 14.3753 38.8057 14.3753C39.8076 14.3753 40.6198 15.1876 40.6198 16.1899Z",
    fill: "url(#paint15_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2211 31.969L27.4471 36.1794C28.4788 37.3841 30.0116 38.1466 31.722 38.1434L32.9392 38.1412L35.0131 38.1373C38.1128 38.1316 40.6209 35.6142 40.6152 32.5145L40.6141 31.9369L23.2211 31.969Z",
    fill: "url(#paint16_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.62 16.1895V30.7102L32.5462 22.6365C30.307 20.475 28.9603 18.1848 28.5376 15.8138C28.3862 14.9644 28.3831 14.1079 28.5187 13.2797C29.2262 13.5275 29.7329 14.2005 29.7329 14.9918V13.5118C29.7329 12.5212 30.5266 11.7158 31.5117 11.6969C32.529 11.6781 33.3619 12.5299 33.3619 13.5471V14.9918C33.3619 13.9903 34.1745 13.1777 35.1768 13.1777C36.1784 13.1777 36.9909 13.9903 36.9909 14.9918V16.1895C36.9909 15.1879 37.8035 14.3754 38.8058 14.3754C39.8074 14.3754 40.62 15.1879 40.62 16.1895Z",
    fill: "url(#paint17_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6201 27.54C40.178 27.54 39.7352 27.4353 39.3396 27.2374C38.144 26.639 35.8093 25.356 33.6068 23.4856C30.7417 21.0525 29.0435 18.4408 28.5592 15.7232C28.1832 13.612 28.7201 11.4569 30.0324 9.8103C31.2478 8.28536 32.9701 7.3943 34.882 7.30105C34.9943 7.29556 35.1083 7.29281 35.2204 7.29281C37.0116 7.29281 38.7026 7.98309 39.9818 9.23658C40.2129 9.46301 40.4259 9.70324 40.6199 9.9554C40.814 9.70324 41.0271 9.46293 41.2581 9.2365C42.5373 7.98309 44.2283 7.29281 46.0196 7.29281C46.1318 7.29281 46.2456 7.29556 46.358 7.30105C48.2699 7.39422 49.9922 8.28536 51.2076 9.81038C52.5199 11.457 53.0569 13.6121 52.6806 15.7232C52.1965 18.4407 50.4983 21.0524 47.6332 23.4856C45.4308 25.3559 43.0961 26.6389 41.9004 27.2374C41.5049 27.4354 41.0621 27.54 40.6201 27.54Z",
    fill: "url(#paint18_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6198 5.78816C39.9255 5.78816 39.3627 5.22533 39.3627 4.53106V1.91702C39.3627 1.22282 39.9255 0.66 40.6198 0.66C41.314 0.66 41.8769 1.22282 41.8769 1.9171V4.53114C41.8769 5.22533 41.314 5.78816 40.6198 5.78816Z",
    fill: "url(#paint19_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3805 6.64461C36.8896 7.13551 36.0937 7.13551 35.6027 6.64461L33.7543 4.79621C33.2634 4.30531 33.2634 3.50939 33.7543 3.01841C34.2452 2.52751 35.0411 2.52751 35.532 3.01841L37.3804 4.8668C37.8715 5.35771 37.8715 6.15371 37.3805 6.64461Z",
    fill: "url(#paint20_linear_32_1243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8594 6.64461C43.3685 6.15371 43.3685 5.35778 43.8594 4.8668L45.7078 3.01841C46.1987 2.52751 46.9946 2.52751 47.4856 3.01841C47.9765 3.50931 47.9765 4.30523 47.4856 4.79614L45.6372 6.64453C45.1462 7.13551 44.3503 7.13551 43.8594 6.64461Z",
    fill: "url(#paint21_linear_32_1243)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_1243",
    x1: 46.1186,
    y1: 23.484,
    x2: 52.1764,
    y2: 33.0792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32_1243",
    x1: 46.5734,
    y1: 27.8525,
    x2: 47.5408,
    y2: 31.8263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32_1243",
    x1: 50.1182,
    y1: 25.5498,
    x2: 55.3934,
    y2: 37.4086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32_1243",
    x1: 50.9532,
    y1: 20.506,
    x2: 56.3535,
    y2: 20.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_32_1243",
    x1: 47.15,
    y1: 18.1976,
    x2: 52.5225,
    y2: 18.1976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_32_1243",
    x1: 43.6739,
    y1: 18.9378,
    x2: 49.2041,
    y2: 18.9378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_32_1243",
    x1: 40.2799,
    y1: 21.1048,
    x2: 45.9326,
    y2: 21.1048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_32_1243",
    x1: 48.4599,
    y1: 34.8282,
    x2: 46.5906,
    y2: 41.0594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89580",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_32_1243",
    x1: 51.814,
    y1: 26.5166,
    x2: 45.6963,
    y2: 21.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89580",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_32_1243",
    x1: 28.9679,
    y1: 21.6513,
    x2: 42.3012,
    y2: 36.8147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_32_1243",
    x1: 31.3255,
    y1: 28.0831,
    x2: 35.4431,
    y2: 34.5537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_32_1243",
    x1: 25.9303,
    y1: 26.7046,
    x2: 30.7539,
    y2: 37.0968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_32_1243",
    x1: 30.2872,
    y1: 20.506,
    x2: 24.8868,
    y2: 20.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_32_1243",
    x1: 34.0901,
    y1: 18.1976,
    x2: 28.7175,
    y2: 18.1976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_32_1243",
    x1: 37.5661,
    y1: 18.9378,
    x2: 32.0359,
    y2: 18.9378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_32_1243",
    x1: 40.9604,
    y1: 21.1048,
    x2: 35.3076,
    y2: 21.1048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_32_1243",
    x1: 32.7802,
    y1: 34.8282,
    x2: 34.6496,
    y2: 41.0594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89580",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_32_1243",
    x1: 45.0913,
    y1: 32.1228,
    x2: 37.9801,
    y2: 21.5607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89580",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_32_1243",
    x1: 36.763,
    y1: 11.0241,
    x2: 47.5907,
    y2: 21.8519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#972437"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_32_1243",
    x1: 39.5002,
    y1: 3.22651,
    x2: 42.9916,
    y2: 3.22651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97DA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#91D67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3049,
    stopColor: "#81CC75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4987,
    stopColor: "#66BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7084,
    stopColor: "#41A461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    stopColor: "#128653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017B4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_32_1243",
    x1: 34.6422,
    y1: 5.67239,
    x2: 37.1106,
    y2: 3.20398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97DA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#91D67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3049,
    stopColor: "#81CC75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4987,
    stopColor: "#66BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7084,
    stopColor: "#41A461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    stopColor: "#128653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017B4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_32_1243",
    x1: 44.8424,
    y1: 3.95268,
    x2: 47.3109,
    y2: 6.42114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97DA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#91D67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3049,
    stopColor: "#81CC75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4987,
    stopColor: "#66BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7084,
    stopColor: "#41A461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    stopColor: "#128653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017B4E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_1243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 40,
    fill: "white",
    transform: "translate(0.620056 0.66)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqHeart);
export default __webpack_public_path__ + "static/media/FAQ_heart.289d5fd538e407af2fc0c7d45ccd5a9a.svg";
export { ForwardRef as ReactComponent };